module.exports = __webpack_public_path__ + "img/34.f10baf30.png";